


























import IconBase from "@/components/common/IconBase.vue";
import Icons from "@/components/icons/Icons.vue";

export default {
  name: "CatalogLinks",
  props: {
    items: { type: Array, default: () => [] },
  },
  components: {
    IconBase,
    Icons,
  },
  data() {
    return {
      viewBox: "0 0 64 64",
      width: 64,
      height: 64,
      color: "#ffc000",
    };
  },
};
